<script>
    import { createEventDispatcher } from 'svelte';
    import Fa from 'svelte-fa'
    import { faArrowDownUpAcrossLine } from '@fortawesome/free-solid-svg-icons'
    
    const dispatch = createEventDispatcher();

    function clickExecuted() {
        dispatch('clicked', {
            
        });
    }
</script>

<div class="IconTransfers" on:click={clickExecuted}>
    <Fa icon={faArrowDownUpAcrossLine} />
</div>

<style>
    .IconTransfers {
        cursor: pointer;
        color: yellow;
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        transform: rotate(90deg);
    }
</style>